import styled from 'styled-components';

import { FormField } from '@xing-com/text-field';
import { space4XL, spaceL, spaceXXL, spaceM, spaceS } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

export const Form = styled.form<{ $isLoggedOut?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ $isLoggedOut }) =>
    $isLoggedOut ? `36px ${spaceL} ${spaceXXL}` : `${space4XL} ${spaceL}`};
  gap: ${spaceL};
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spaceS};
`;

export const Text = styled(BodyCopy)`
  text-align: center;
`;

export const Input = styled(FormField)`
  width: 100%;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spaceM};
  margin-top: ${spaceS};
`;
